import classNames from "classnames";
import { formatDate } from "../../helperFunctions";

export const TimeText = ({
  timeString,
  showTime = true,
  className,
}: {
  timeString: string;
  showTime?: boolean;
  className?: string;
}) => {
  return (
    <p
      className={classNames(
        "min-w-fit line-clamp-1 whitespace-nowrap",
        className
      )}
    >
      <span>{formatDate(timeString, "DD MMM, YYYY")}</span>{" "}
      {showTime && (
        <span className="opacity-40 text-[10px]">
          {formatDate(timeString, "hh:mm A")}
        </span>
      )}
    </p>
  );
};
